module.exports = __webpack_public_path__ + "img/contact-banner.7a08bf1a.jpg";